import React from 'react';
import styles from './Blocks.module.css';

const FooterItemContainer = (props) => {
  const {children, className} = props
return (
  <div
    className={`
      ${styles.item_container}
      ${className}
      d-flex
      flex-column
      flex-wrap
      justify-content-start
      align-items-start
      w-fit-content
    `}
  >
    {children}
  </div>
);};

export default FooterItemContainer;
